/* eslint-disable */
export default {
  noActiveCalls: 'Ei käynnissä olevia puheluita',
  noRecords: 'Hakutuloksia ei löytynyt.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
